var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Utils
import styled, { css } from 'styled-components';
/**
 * @deprecated Please do not use this component further.
 * Please use existing typography components:
 * Heading, Label, Subheading, Paragraph, PrefixLabel
 */
export var Typography = styled.h1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  text-decoration: ", ";\n  cursor: ", ";\n  display: ", ";\n  margin: ", ";\n  font-family: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  font-style: ", ";\n  ", "\n"], ["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  text-decoration: ", ";\n  cursor: ", ";\n  display: ", ";\n  margin: ", ";\n  font-family: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  font-style: ", ";\n  ",
    "\n"])), function (_a) {
    var fontSize = _a.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : '16px';
}, function (_a) {
    var fontWeight = _a.fontWeight;
    return fontWeight !== null && fontWeight !== void 0 ? fontWeight : 'normal';
}, function (_a) {
    var color = _a.color;
    return color !== null && color !== void 0 ? color : null;
}, function (_a) {
    var textDecoration = _a.textDecoration;
    return textDecoration !== null && textDecoration !== void 0 ? textDecoration : null;
}, function (_a) {
    var cursor = _a.cursor;
    return cursor !== null && cursor !== void 0 ? cursor : 'inherit';
}, function (_a) {
    var display = _a.display;
    return display !== null && display !== void 0 ? display : 'inherit';
}, function (_a) {
    var margin = _a.margin;
    return margin !== null && margin !== void 0 ? margin : '';
}, function (_a) {
    var _b;
    var theme = _a.theme, fontFamily = _a.fontFamily;
    return fontFamily !== null && fontFamily !== void 0 ? fontFamily : (_b = theme === null || theme === void 0 ? void 0 : theme.typography) === null || _b === void 0 ? void 0 : _b.fontFamily;
}, function (_a) {
    var letterSpacing = _a.letterSpacing;
    return letterSpacing !== null && letterSpacing !== void 0 ? letterSpacing : null;
}, function (_a) {
    var lineHeight = _a.lineHeight;
    return lineHeight !== null && lineHeight !== void 0 ? lineHeight : null;
}, function (_a) {
    var fontStyle = _a.fontStyle;
    return fontStyle !== null && fontStyle !== void 0 ? fontStyle : null;
}, function (_a) {
    var textOverflow = _a.textOverflow;
    return textOverflow && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "], ["\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "])));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=Typography.js.map